module.exports = __webpack_public_path__ + "img/oax.6242ff70.svg";